import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const SET_CUSTOM_PROPERTY_FOR_LINE_MUTATION = gql`
  mutation setCustomPropForLine(
    $documentVersion: DocumentVersionInput,
    $lineId: String!,
    $key: String!,
    $stringValue: String
    ) {
      quotes {
        modify(documentVersion: $documentVersion) {
          line (id: $lineId) {
            setCustomPropertyValue(key: $key, stringValue: $stringValue) {
              id
            }
          }
        }
      }
    }
`;

@Injectable({
  providedIn: 'root'
})
export class SetCustomPropertyForLineMutation extends Mutation<RootMutation> {
  document = SET_CUSTOM_PROPERTY_FOR_LINE_MUTATION;
}
